import React from 'react';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/index.tsx';
import InactiveProjectsDirectory from '@atlassian/jira-inactive-projects-directory-base/src/ui/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import {
	ContextualAnalyticsData,
	SCREEN,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import messages from './messages.tsx';
import type { Props, TrashedProjectsDirectoryType } from './types.tsx';

export const TrashedProjectsDirectory: TrashedProjectsDirectoryType = ({
	intl: { formatMessage },
}: Props) => (
	<ContextualAnalyticsData sourceName="trashedProjects" sourceType={SCREEN}>
		<DocumentTitle title={formatMessage(messages.documentTitle)} />
		<PageLayout>
			<InactiveProjectsDirectory status="deleted" />
		</PageLayout>
		<FireScreenAnalytics />
	</ContextualAnalyticsData>
);

export default injectIntl(TrashedProjectsDirectory);
